import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_level_monitoring_event_inv_label_hdr_link_RowClass } from '../../../dbschema/bl_inv_stock_level_monitoring_event_inv_label_hdr_link.model';

export class StockLevelMonitoringEventInvLabelHdrLinkModel extends BaseContainerModel {
  bl_inv_stock_level_monitoring_event_inv_label_hdr_link: bl_inv_stock_level_monitoring_event_inv_label_hdr_link_RowClass = new bl_inv_stock_level_monitoring_event_inv_label_hdr_link_RowClass();
}
